export type ViaCepSuccess = {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
};

type ViaCepJson = ViaCepSuccess & { erro?: boolean | string };

/**
 * Free CEP lookup (Brazil). Does not use API keys.
 * @see https://viacep.com.br/
 */
export async function fetchAddressByCep(
  cepDigits: string
): Promise<ViaCepSuccess | null> {
  const clean = cepDigits.replace(/\D/g, "");
  if (clean.length !== 8) return null;

  const res = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
  if (!res.ok) return null;

  const data = (await res.json()) as ViaCepJson;
  if (data.erro) return null;

  return data;
}
